import { Overlays } from 'components/ui/overlays';
import React from 'react';
import { useDispatch } from 'react-redux';
import config from 'utils/config';
import { getCookie } from 'utils/commonFunctions';
import {
  Api,
  useGetOtherUserTeamQuery,
  useGetUserCreatedTeamQuery,
  useGetTeamCreatedGamedaysQuery
} from 'api';
import { usePlayerListsQuery } from 'api/feeds';
import MatchCard from 'components/ui/matchCard';
import Loader from 'components/ui/loader';
import { IMG_BASE_PATH } from 'utils/constants';
import FormationPlayerCard from '../ui/formationPlayerCard';
import Typo from '../ui/typo';
import TotalPoints from 'components/ui/totalPoints';
import { setToastMessage, closeToast } from '../../store/slice/toastMessageSlice';
import ToastMessage from 'components/ui/toastMessage';

const OtherUserTeamOverlay = ({
  handleOtherUserTeamOverlay,
  activeDropDown,
  activeTab,
  selectedTeamIdData,
  fixtureData
}) => {
  const gameCookie = getCookie(config.gameCookieName);
  const dispatch = useDispatch();
  const gamedayId = activeDropDown?.id ?? fixtureData?.gameday_id;

  const {
    data: otherUserTeamData,
    isLoading: otherUserLoading,
    error: otherUserError
  } = useGetOtherUserTeamQuery(
    {
      guid: gameCookie?.guid,
      gamedayId: gamedayId,
      teamId: selectedTeamIdData?.teamid || '',
      optType: activeTab === 1 ? 1 : 2,
      socialId: selectedTeamIdData?.teamSocialId
    },
    { refetchOnMountOrArgChange: true }
  );

  const {
    data: playerlistdata,
    isLoading: playerLoading,
    error: playerError
  } = usePlayerListsQuery({ gamedayId: gamedayId });

  if (otherUserLoading || playerLoading) {
    return <Loader />;
  }

  if (otherUserTeamData?.Data?.Value?.ret_type === 3) {
    handleOtherUserTeamOverlay(false);
    dispatch(
      setToastMessage({
        toastMessageState: {
          open: true,
          message: `The user has not created a team for match ${gamedayId}`,
          type: 3
        }
      })
    );
    return;
  }

  const selectedPlayer = playerlistdata?.Data?.Value?.Players?.filter((item) =>
    otherUserTeamData?.Data?.Value?.plyid?.includes(item.id)
  );

  const skillroles = ['BATTER', 'ALL ROUNDER', 'BOWLER',];

  return (
    <>
      <Overlays
        overlayName={'opponentTeamsInfo'}
        overlayConfig={{
          noOverlayHead: true,
          overlayCloseConfig: false,
          noOverlayClose: true,
          noOverlayFoot: false,
          noOverlayReset: false,
          title: selectedTeamIdData?.teamName,
          titleTransKey: selectedTeamIdData?.teamName,
          onClickProp: () => {
            handleOtherUserTeamOverlay(false);
          }
        }}
      >
        <div className='si-opponentTeamsInfo__wrap'>
          <div className='si-matchCardList si-matchCardList--createTeam '>
            <MatchCard
              showCTA={false}
              openEvent={fixtureData}
              hideTimer={false}
              matchesData={[fixtureData]}
              matchgameid={fixtureData}
              showPostCard={true}
              totalGdPoints={otherUserTeamData?.Data?.Value?.gdpt}
              lateOnboard={otherUserTeamData?.Data?.Value?.is_late_onboarded_user}
            />
            <div className='si-selectionCard__list'>
              {skillroles?.map((skillName, index) => {
                const player = selectedPlayer?.find((p) => p?.skill_name === skillName);
                const background = player
                  ? `var(--${config.skillShortName[player?.skill_id].toLowerCase()}-bg)`
                  : null;

                return (
                  <div
                    key={index}
                    className={`si-selectionCard ${player ? 'si-select' : ''}`}
                    style={{ background }}
                  >
                    {player ? (
                      <div className='si-selectionCard__player-wrap'>
                        <FormationPlayerCard
                          thumbnail={player?.id || 'no-image'}
                          plyrName={player?.short_name || 'No Player'}
                          fallback={`${IMG_BASE_PATH}images/players/2.png`}
                        />
                      </div>
                    ) : (
                      <div className='si-selectionCard__head'>
                        <Typo
                          transKey={`player_skill_${skillName}`}
                          component='h4'
                          className='si-selectionCard__heading'
                        >
                          {`Skill ${index + 1}`}
                        </Typo>
                      </div>
                    )}
                    <div className='si-selectionCard__points-wrap'>
                      <TotalPoints totalPoints={player?.gd_pts} />
                    </div>
                  </div>
                );
              })}
            </div>

            {otherUserTeamData?.Data?.Value?.is_late_onboarded_user ? (
              <div className='si-notification__fixed'>
                <ToastMessage
                  open={true}
                  type={5}
                  transMessage={'lateonboarded_score'}
                  message={
                    'This was a late onboard team, so the score is 90% of the total XXX × 0.90 = XXX points).'
                  }
                />
              </div>
            ) : null}
          </div>
        </div>
      </Overlays>
    </>
  );
};

export default OtherUserTeamOverlay;
